import React, { useEffect, useState } from 'react';

/**
 * Takım rozeti: logo varsa görsel, yoksa takımın baş harflerinden üretilmiş
 * monogram.
 *
 * Konsensüs oran kaynakları (Sportsbook API, The Odds API) logo döndürmez;
 * logolar panelden ada göre çözülür ve zamanla dolar. Logosu henüz çözülmemiş
 * takımı ikonsuz bırakmak listeyi boş gösteriyordu — monogram her takıma
 * ayırt edilebilir bir renk ve harf verir. Renk addan türetildiği için aynı
 * takım her yerde aynı rozeti alır.
 */

// Kulüp ekleri baş harfe girmemeli: "FC St. Pauli" rozeti "FS" değil "SP"
// olmalı, yoksa aynı ligdeki bütün takımlar "F" ile başlıyor görünür.
const AFFIXES = new Set([
  'fc', 'cf', 'sc', 'sv', 'vfl', 'vfb', 'tsv', 'fsv', 'bsc', 'afc', 'ac',
  'as', 'ss', 'ssc', 'us', 'cd', 'ud', 'rc', 'rcd', 'sd', 'ca', 'cs', 'if',
  'ik', 'bk', 'fk', 'sk', 'gk', 'nk', 'hk', 'mk', 'ff', 'gif', 'jk', 'pfc',
  'kfc', 'rkc', 'club', 'clube', 'calcio', 'the',
]);

const tokensOf = (name) => String(name || '')
  .replace(/[^\p{L}\p{N}\s]/gu, ' ')
  .split(/\s+/)
  .filter(Boolean);

export const teamInitials = (name) => {
  const tokens = tokensOf(name);
  const meaningful = tokens.filter((t) => !AFFIXES.has(t.toLowerCase()));
  const source = meaningful.length ? meaningful : tokens;
  if (!source.length) return '?';
  if (source.length === 1) return source[0].slice(0, 2).toUpperCase();
  return (source[0][0] + source[source.length - 1][0]).toUpperCase();
};

// Ad → sabit renk. Basit bir toplama karması yeterli: amaç güvenlik değil,
// aynı takımın her ekranda aynı rengi almasıdır.
export const teamHue = (name) => {
  const text = String(name || '');
  let hash = 0;
  for (let i = 0; i < text.length; i += 1) {
    hash = (hash * 31 + text.charCodeAt(i)) % 360;
  }
  return hash;
};

const TeamBadge = ({ name, logo, size = 26, className = '' }) => {
  const [failed, setFailed] = useState(false);

  useEffect(() => { setFailed(false); }, [logo]);

  const style = { width: size, height: size };

  if (logo && !failed) {
    return (
      <img
        src={logo}
        alt=""
        title={name || ''}
        style={style}
        className={`object-contain shrink-0 ${className}`.trim()}
        loading="lazy"
        onError={() => setFailed(true)}
      />
    );
  }

  const hue = teamHue(name);
  return (
    <span
      title={name || ''}
      aria-hidden="true"
      className={`inline-flex items-center justify-center rounded-full font-bold shrink-0 ${className}`.trim()}
      style={{
        ...style,
        fontSize: Math.max(9, Math.round(size * 0.38)),
        letterSpacing: '0.02em',
        color: `hsl(${hue} 85% 82%)`,
        background: `linear-gradient(140deg, hsl(${hue} 55% 26%), hsl(${(hue + 40) % 360} 55% 16%))`,
        border: `1px solid hsl(${hue} 60% 40% / 0.55)`,
      }}
    >
      {teamInitials(name)}
    </span>
  );
};

export default TeamBadge;
